/**
 * @generated SignedSource<<4f62a8dd3995c4002d3458cadfdcb9b7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PictureDialogClearMutation$variables = Record<PropertyKey, never>;
export type PictureDialogClearMutation$data = {
  readonly clearLearnerPicture: {
    readonly learner: {
      readonly id: string;
      readonly picture: {
        readonly preset: string | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type PictureDialogClearMutation = {
  response: PictureDialogClearMutation$data;
  variables: PictureDialogClearMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnerPicturePayload",
    "kind": "LinkedField",
    "name": "clearLearnerPicture",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnerPicture",
            "kind": "LinkedField",
            "name": "picture",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preset",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PictureDialogClearMutation",
    "selections": (v0/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PictureDialogClearMutation",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "061a04b04e24dbfa482b126457c87716",
    "id": null,
    "metadata": {},
    "name": "PictureDialogClearMutation",
    "operationKind": "mutation",
    "text": "mutation PictureDialogClearMutation {\n  clearLearnerPicture {\n    learner {\n      id\n      picture {\n        preset\n        url\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e51806d3e021b80a1c05177035cbd414";

export default node;
